import { render, staticRenderFns } from "./calCustomers.vue?vue&type=template&id=280e47d4&scoped=true"
import script from "./calCustomers.vue?vue&type=script&lang=js"
export * from "./calCustomers.vue?vue&type=script&lang=js"
import style0 from "./calCustomers.vue?vue&type=style&index=0&id=280e47d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e47d4",
  null
  
)

export default component.exports